import React from 'react';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { Formik, Form as FormikForm, FieldArray } from 'formik';
import { Row, Col } from 'react-bootstrap5';

import Modal from 'components/new_ui/Modal/Modal';
import HorizontalSelectField from 'components/new_ui/Form/HorizontalSelectField';
import { useContext } from 'components/Managers/Billing/Context';
import Footer from 'components/Widgets/Profile/FormFooter';

export default function Index({ show, onHide, policy }) {
  const { dispatch, actions, state: { enterpriseId, paymentMethods } } = useContext();

  const formSchema = Yup.object().shape({
    // plans: Yup.array().of(
    //  Yup.object().shape({
    //    paymentMethodId: Yup.number().required('required').nullable(),
    //  }),
    // ),
  });

  const onSubmit = (values, { setSubmitting }) => {
    actions.assignPaymentMethods(
      values,
      () => {
        setSubmitting(false);
        onHide();
        actions.loadPaymentMethods(dispatch);
        actions.loadPolicy(dispatch, enterpriseId);
      },
    );
  };

  const plans = policy.attributes.plans.filter((plan) => plan.attributes.active);

  const initValues = {
    plans: plans.map((item) => ({
      id: item.id,
      name: item.attributes.name,
      paymentMethodId: item.attributes.payment_information_id,
    })),
  };

  const notFreePlans = plans.filter((item) => !item.attributes.is_free);

  return (
    <Modal show={show} size="lg">
      <div className="text-center mb-4">
        <h2>Link Plans To Payment Method</h2>
        {notFreePlans.length === 0 && (
          <p>There are no paid plans to link.</p>
        )}
      </div>
      <Formik
        validationSchema={formSchema}
        initialValues={initValues}
        onSubmit={onSubmit}
      >
        {({ isSubmitting }) => (
          <FormikForm className="needs-validation" noValidate="">
            <FieldArray name="plans">
              {(_helpers) => (
                <div>
                  {notFreePlans.map((item, index) => (
                    <Row key={item.id}>
                      <Col>{item.attributes.name}</Col>
                      <Col>
                        <HorizontalSelectField
                          name={`plans.${index}.paymentMethodId`}
                          isClearable={false}
                          placeholder={paymentMethods === null ? 'Loading...' : 'Select Payment Method'}
                          options={paymentMethods === null ? [] : paymentMethods.map((method) => ({
                            label: method.attributes.label,
                            value: method.id,
                          }))}
                        />
                      </Col>
                    </Row>
                  ))}
                </div>
              )}
            </FieldArray>
            <Footer loading={isSubmitting} onCancel={() => onHide()} />
          </FormikForm>
        )}
      </Formik>
    </Modal>
  );
}

Index.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  policy: PropTypes.object.isRequired,
};
